export default "__VITE_ASSET__CNfV1WJ$__"